module.exports = __webpack_public_path__ + "static/media/logo.cf66dfb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/masonryGallery/logo.jpg
// module id = 261
// module chunks = 0